/**
 * The translation that moves a clipboard entry's bounding-box center onto `viewportCenter` (the
 * visible viewport center, canvas coordinates), from each element's in-place base position.
 * Null when the entry holds nothing to measure.
 */
export function computeViewportCenteredPasteOffset({
  shapeSnapshots,
  textSnapshots,
  shapeBases,
  textBases,
  viewportCenter,
}: {
  shapeSnapshots: readonly { width: number; height: number }[]
  textSnapshots: readonly { width: number; height: number }[]
  shapeBases: readonly { x: number; y: number }[]
  textBases: readonly { x: number; y: number }[]
  viewportCenter: { x: number; y: number }
}): { dx: number; dy: number } | null {
  const minXs = [...shapeBases.map((b) => b.x), ...textBases.map((b) => b.x)]
  const maxXs = [
    ...shapeSnapshots.map((s, i) => shapeBases[i].x + s.width),
    ...textSnapshots.map((s, i) => textBases[i].x + s.width),
  ]
  const minYs = [...shapeBases.map((b) => b.y), ...textBases.map((b) => b.y)]
  const maxYs = [
    ...shapeSnapshots.map((s, i) => shapeBases[i].y + s.height),
    ...textSnapshots.map((s, i) => textBases[i].y + s.height),
  ]

  if (minXs.length === 0) return null

  const groupCenterX = (Math.min(...minXs) + Math.max(...maxXs)) / 2
  const groupCenterY = (Math.min(...minYs) + Math.max(...maxYs)) / 2

  return { dx: viewportCenter.x - groupCenterX, dy: viewportCenter.y - groupCenterY }
}
